<div class="modal-header">
  <h5  *ngIf="emailSent" class="modal-title">Дякуємо за реєстрацію</h5>
  <h5 *ngIf="!emailSent" class="modal-title" >Увійти</h5>
  <button
          type="button"
          class="close"
          (click)="onClose()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  </button>
</div>
<div class="modal-body pb-5" *ngIf="!emailSent">
  <button class="login-button  google-login"
          (click)="loginWithGoogle()">
    <span>Продовжити через Google</span>
    <img src="../assets/icons/google.png" alt="google-logo" />

  </button>
  <div class="w-100 or">або</div>
    <div class="form-control">
      <input [(ngModel)]="email" type="email" placeholder="Email" />
    </div>
    <button class="login-button" (click)="SignInWithEmailLink(email)"
            >Увійти через email</button>
    <p><small>
      Посилання для входу буде надіслано на вашу електронну пошту</small></p>

</div>

<div class="modal-body" *ngIf="emailSent">
    <p class="text-center">
      Ми надіслали електронний лист із підтвердженням на адресу<strong>{{email}}</strong>.</p>
    <p class="text-center">
      Будь ласка, перевірте свою електронну пошту (включаючи папку зі спамом) і натисніть на посилання, щоб підтвердити свою електронну адресу.</p>
</div>
